import React from 'react';
import { motion } from 'framer-motion';
export function ProposalHero() {
  return <section className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#F8F9FA] to-white relative overflow-hidden" data-id="element-216">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03]" data-id="element-217">
        <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(circle at 1px 1px, #1B2A4A 1px, transparent 0)`,
        backgroundSize: '40px 40px'
      }} data-id="element-218" />
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-219">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-220">
          <img src="https://cdn.magicpatterns.com/uploads/rPECazqhHrWF2aBnEWg3gz/beclinical_logo_2.svg" alt="Be Clinical Med Spa" className="h-24 md:h-32 w-auto mx-auto mb-8" data-id="element-221" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-222">
          <p className="text-[#C9A96E] text-sm md:text-base font-semibold tracking-[0.3em] uppercase mb-4" data-id="element-223">
            Google Ads
          </p>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-light text-[#1B2A4A] tracking-tight mb-6" data-id="element-224">
            Campaign Plan
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="space-y-2 text-[#666] text-lg md:text-xl" data-id="element-225">
          <p className="font-medium text-[#1B2A4A]" data-id="element-226">
            Be Clinical Med Spa & Aesthetic Clinic
          </p>
          <p data-id="element-227">San Ramon, California</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-12 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12" data-id="element-228">
          <div className="text-center" data-id="element-229">
            <p className="text-3xl md:text-4xl font-light text-[#1B2A4A]" data-id="element-230">
              $20,000
            </p>
            <p className="text-sm text-[#666] mt-1" data-id="element-231">Monthly Ad Spend</p>
          </div>
          <div className="hidden md:block w-px h-12 bg-[#1B2A4A]/20" data-id="element-232" />
          <div className="text-center" data-id="element-233">
            <p className="text-3xl md:text-4xl font-light text-[#1B2A4A]" data-id="element-234">
              150
            </p>
            <p className="text-sm text-[#666] mt-1" data-id="element-235">Target Bookings/Month</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="mt-16 pt-8 border-t border-[#1B2A4A]/10" data-id="element-236">
          <p className="text-sm text-[#666]" data-id="element-237">
            Prepared by{' '}
            <span className="font-semibold text-[#1B2A4A]" data-id="element-238">LetLois</span> —
            February 2026
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1,
        repeat: Infinity,
        repeatType: 'reverse',
        repeatDelay: 1
      }} className="absolute bottom-12 left-1/2 -translate-x-1/2" data-id="element-239">
          <div className="w-6 h-10 border-2 border-[#1B2A4A]/30 rounded-full flex justify-center pt-2" data-id="element-240">
            <div className="w-1.5 h-3 bg-[#C9A96E] rounded-full" data-id="element-241" />
          </div>
        </motion.div>
      </div>
    </section>;
}